import { type OptionType } from "@vega-core/models/options";
import { m } from "@vega-core/paraglide/messages";
import { useTableFilters } from "@vega-modules/components/Table/TableFilters/hooks/useTableFilters";
import {
  type FilterConfig,
  FilterType,
  TableFilterId,
  type TableFiltersConfig,
} from "@vega-modules/components/Table/TableFilters/types";

export function useCASTableFilters({
  templateOptions,
  isLoading,
}: {
  templateOptions: OptionType[];
  isLoading: boolean;
}) {
  const statusOptions: OptionType[] = [
    { label: m.settings_casManagement_table_active(), value: "true" },
    { label: m.settings_casManagement_table_inactive(), value: "false" },
  ];

  const baseFilters = [
    {
      id: "search",
      type: FilterType.Search,
      label: m.common_search(),
      hideFromModal: true,
      props: {
        placeholder: m.settings_casManagement_filters_searchPlaceholder(),
      },
    },
    {
      id: "active",
      type: FilterType.Dropdown,
      label: m.settings_casManagement_filters_status_label(),
      props: {
        placeholder: m.settings_casManagement_filters_status_all(),
        options: statusOptions,
      },
    },
    {
      id: "templateKey",
      type: FilterType.Dropdown,
      label: m.settings_casManagement_filters_template_label(),
      props: {
        placeholder: m.settings_casManagement_filters_template_all(),
        options: templateOptions,
      },
    },
  ] as const satisfies readonly FilterConfig[];

  const filtersConfig = {
    filters: baseFilters,
    showResetButton: true,
    maxShownFilters: 3,
  } as const satisfies TableFiltersConfig;

  const {
    filterState,
    setFilterValue,
    resetFilters,
    hasActiveFilters,
    activeFilterCount,
    RenderFilters,
  } = useTableFilters({
    id: TableFilterId.CASManagement,
    config: filtersConfig,
    isLoading,
    syncWithURL: false,
  });

  return {
    filterState,
    setFilterValue,
    resetFilters,
    hasActiveFilters,
    activeFilterCount,
    RenderFilters,
  };
}
